export default "__VITE_ASSET__BHv9pnhW__"